<template>
  <div :class="{ round: roundSlots }" class="roulette_container">
    <div class="roulette-inner">
      <div ref="roulette" class="roulette" style="display: none">
        <img :src="image0" class="rouletteN" alt="0" />
        <img :src="image1" class="rouletteN" alt="1" />
        <img :src="image2" class="rouletteN" alt="2" />
        <img :src="image3" class="rouletteN" alt="3" />
        <img :src="image4" class="rouletteN" alt="4" />
        <img :src="image5" class="rouletteN" alt="5" />
        <img :src="image6" class="rouletteN" alt="6" />
        <img :src="image7" class="rouletteN" alt="7" />
        <img :src="image8" class="rouletteN" alt="8" />
        <img :src="image9" class="rouletteN" alt="9" />
      </div>
    </div>
  </div>
</template>

<script>
import jquery from "jquery";

window.$ = jquery;
window.jQuery = jquery;
require("../../../../../assets/static/js/roulette.js");
import Image0 from "../../../../../assets/static/img/numbers/R-0.png";
import Image1 from "../../../../../assets/static/img/numbers/R-1.png";
import Image2 from "../../../../../assets/static/img/numbers/R-2.png";
import Image3 from "../../../../../assets/static/img/numbers/R-3.png";
import Image4 from "../../../../../assets/static/img/numbers/R-4.png";
import Image5 from "../../../../../assets/static/img/numbers/R-5.png";
import Image6 from "../../../../../assets/static/img/numbers/R-6.png";
import Image7 from "../../../../../assets/static/img/numbers/R-7.png";
import Image8 from "../../../../../assets/static/img/numbers/R-8.png";
import Image9 from "../../../../../assets/static/img/numbers/R-9.png";

export default {
  name: "VerticalSlotsMachine",
  props: {
    stopNumber: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      default: 3
    },
    speed: {
      type: Number,
      default: 20
    },
    spin: {
      type: Boolean,
      default: false
    },
    roundSlots: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      image0: Image0,
      image1: Image1,
      image2: Image2,
      image3: Image3,
      image4: Image4,
      image5: Image5,
      image6: Image6,
      image7: Image7,
      image8: Image8,
      image9: Image9
    };
  },
  watch: {
    spin: {
      handler(value) {
        if (value) {
          jquery(this.$refs.roulette).roulette("start");
        } else {
          jquery(this.$refs.roulette).roulette("stop");
        }
      }
    }
  },
  mounted() {
    const context = this,
      options = {
        speed: this.speed,
        // duration: this.duration,
        stopImageNumber: this.stopNumber,
        startCallback() {
          context.$emit("start");
          console.log("start");
        },
        slowDownCallback() {
          context.$emit("slowDown");
          console.log("slowDown");
        },
        stopCallback() {
          context.$emit("stop");
          console.log("stop");
        }
      };

    jquery(this.$refs.roulette).roulette(options);
  }
};
</script>

<style lang="scss" scoped>
div.roulette {
}

div.roulette-inner {
  left: 33px;
}

div.roulette {
}

div.roulette_container {
  background-color: rgb(253, 252, 253);
  width: 150px;
  height: 150px;
  border: 1px solid rgba(253, 252, 253, 0.31);
  box-shadow: 0 0 3px lightpink;
}

div.roulette_container.round {
  border-radius: 200px;
}

img.rouletteN {
  margin: auto;
  height: 130px;
  width: 110px;
}
</style>
